import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormControl } from "@angular/forms";
import { StripeService, StripeCardComponent } from 'ngx-stripe';
import { StripeCardElementOptions, StripeElementsOptions } from '@stripe/stripe-js';
import { ApiService } from 'src/app/_services/api.service';
import { StripePaymentModel } from 'src/app/_models/Payment/stripe-payment.model';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PriceRecurringType } from 'src/app/_models/Enums/PriceRecurringTypes';
import { MembershipPlanModel } from 'src/app/_models/Company/membership-plan-model';
import { CurrencyModel } from 'src/app/_models/Company/currency.model';
import { StripeCheckoutModel } from 'src/app/_models/Payment/stripe-checkout.model';
import { switchMap } from 'rxjs';
import { HalkbankPaymentModel } from 'src/app/_models/Payment/halkbank.model';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {
  @ViewChild('HalkForm') HalkForm: ElementRef;
  @ViewChild(StripeCardComponent) card: StripeCardComponent;
  cardOptions: StripeCardElementOptions = {
    hidePostalCode: true,
    style: {
      base: {
        iconColor: '#FFFFFF',
        color: '#FFFFFF',
        fontWeight: '600',
        fontFamily: '"Mulish", sans-serif',
        fontSize: '18px',
        '::placeholder': {
          color: '#CFD7E0'
        },
        padding: '10px'
      },
      invalid: {
        iconColor: '#f05a1e',
        color: '#f05a1e'
      }
    }
  };

  elementsOptions: StripeElementsOptions = {
    locale: 'en'
  };
  error: string;
  stripeTest: UntypedFormGroup;
  membershipPlan: MembershipPlanModel;
  currencyInfo: CurrencyModel;
  allowedPaymentProcessors: any[];
  selectedPaymentProcessor: string = '';
  public spinner: boolean = false;
  monthly = PriceRecurringType.Monthly;
  yearly = PriceRecurringType.Yearly;
  basis: string;
  oneTime: boolean = false;
  recuringType: boolean = false;

  halkbank:HalkbankPaymentModel = new HalkbankPaymentModel();
  // HalkPaymentPorcessor = {id: '2', processorName: 'Halkbank'};//need to be defind on BE
  postingToHalk = false;//should be false
  HalkFormGroup: UntypedFormGroup = new UntypedFormGroup({});
  

  constructor(
    private fb: UntypedFormBuilder,
    private stripeService: StripeService,
    private apiService: ApiService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {
    if (this.config.data != undefined && this.config.data.membershipPlan && this.config.data.currencyInfo) {
      this.membershipPlan = this.config.data.membershipPlan;
      this.currencyInfo = this.config.data.currencyInfo;
      this.allowedPaymentProcessors = this.config.data.allowedPaymentProcessors;
    }
  }

  ngOnInit(): void {
    this.stripeTest = this.fb.group({
      name: ['', [Validators.required]]
    });
    // this.goToCheckoutHalk();
    this.HalkFormGroup = this.fb.group({
      clientid: [''],
      storetype: [''],
      hash: [''],
      trantype: [''],
      amount: [''],
      currency:[''],
      oid:[''],
      okUrl:[''],
      failUrl:[''],
      lang:[''],
      rnd:[''],
      encoding:[''],
      refreshtime:[''],
      instalment:[''],
      RecurringPaymentNumber:[''],
      RecurringFrequencyUnit:[''],
      RecurringFrequency:[''],
    })
    //here halk
    // this.allowedPaymentProcessors.map(a=>{
    //   if(a.processorName != this.HalkPaymentPorcessor.processorName){
    //     this.allowedPaymentProcessors.push(this.HalkPaymentPorcessor) //thats why we push to the array
    //   } else {
    //     this.allowedPaymentProcessors.pop() //remove duplecates

    //   }
    // })
  }
  choosedPaymentProcessor(){
    // console.log(this.selectedPaymentProcessor)
  }

  changeStatus(basis:any){
    if(basis==1 || basis==2){
      this.oneTime=true;
      this.recuringType=false;
    }
    if(basis==3 || basis==4){
      this.oneTime=false;
      this.recuringType=true;
    }
  }

  checkout(basis: any){
    const paymentCredentials = new StripeCheckoutModel();
    paymentCredentials.productId = this.membershipPlan.id;
    if(basis == 3){
      paymentCredentials.recurringTypeId = PriceRecurringType.Monthly;
    } else {
      paymentCredentials.recurringTypeId = PriceRecurringType.Yearly;
    }
    this.spinner=true;
    this.apiService.getsessionforsubscription(paymentCredentials)
    .pipe(
      switchMap(session => {
        return this.stripeService.redirectToCheckout({ sessionId: session.id })
      })
    )
    .subscribe((result)=>{
      this.spinner=false;
      if (result.error) {
        alert(result.error.message);
      }
    },error => {
      // alert(error.message);
    })
  }
  payWithStripe(basis: any): void {
    //@ts-ignore
    const name = this.stripeTest.get('name').value;
    this.stripeService
      .createToken(this.card.element, { name })
      .subscribe((result) => {
        if (result.token) {
          this.spinner = true;
          const paymentCredentials = new StripePaymentModel();
          paymentCredentials.token = result.token.id;
          //@ts-ignore
          paymentCredentials.cardId = result.token.card.id;
          paymentCredentials.productId = this.membershipPlan.id;
          if (basis == 1) {
            paymentCredentials.priceRecurringTypeId = PriceRecurringType.Monthly;
            this.apiService.makepayment(paymentCredentials).subscribe((result) => {
              this.spinner = false;
              this.ref.close(true);
            }, (error) => {
              this.spinner = false;
              if(error.message.includes("Invalid Parameters")){
                this.error = "Card Declined!";
              }
              else {
                this.error = error.message;
              }
            });
          } else if (basis == 2) {
            paymentCredentials.priceRecurringTypeId = PriceRecurringType.Yearly;
            this.apiService.makepayment(paymentCredentials).subscribe((result) => {
              this.spinner = false;
              this.ref.close(true);
            }, (error) => {
              this.spinner = false;
              this.error = error.message;
            });
          }
        } else if (result.error) {
          //@ts-ignore
          this.error = result.error.message;
        }
      });
  }

  //here Halk
  goToCheckoutHalk() {
    var amount: number = 1;
    // this.apiService.generateHash(amount).subscribe((result)=>{
    //   this.halkbank.hash = result.hash;
    //   this.halkbank.clientid = result.clientId;
    //   // this.halkbank.storetype = result.storeType;
    //   this.halkbank.trantype = result.transactionType;
    //   this.halkbank.amount = result.amount;
    //   this.halkbank.oid = result.oid;
    //   this.halkbank.okUrl = result.okUrl;
    //   this.halkbank.failUrl = result.failUrl;
    //   this.halkbank.rnd = result.rnd;
    //   this.HalkFormGroup.patchValue({hash: result.hash});
    //   this.HalkFormGroup.patchValue({clientid: result.clientId});
    //   this.HalkFormGroup.patchValue({storetype: this.halkbank.storetype});
    //   this.HalkFormGroup.patchValue({trantype: result.transactionType});
    //   this.HalkFormGroup.patchValue({amount: result.amount});
    //   this.HalkFormGroup.patchValue({currency: this.halkbank.currency});
    //   this.HalkFormGroup.patchValue({oid: result.oid});
    //   this.HalkFormGroup.patchValue({okUrl: result.okUrl});
    //   this.HalkFormGroup.patchValue({failUrl: result.failUrl});
    //   this.HalkFormGroup.patchValue({lang: this.halkbank.lang});
    //   this.HalkFormGroup.patchValue({rnd: result.rnd});
    //   this.HalkFormGroup.patchValue({encoding: this.halkbank.encoding});
    //   this.HalkFormGroup.patchValue({refreshtime: this.halkbank.refreshtime});
    //   this.HalkFormGroup.patchValue({RecurringFrequencyUnit: 'M'});
    //   this.HalkFormGroup.patchValue({RecurringFrequency: '1'});
    //   this.spinner = true;
    //   this.postingToHalk = true;
    //   },(error) => {
    //     this.spinner = false;
    //     this.postingToHalk = false;
    //   })
     this.apiService.generateHashForProduction(amount).subscribe((result)=>{
      this.halkbank.hash = result.hash;
      this.halkbank.clientid = result.clientId;
      // this.halkbank.storetype = result.storeType;
      this.halkbank.trantype = result.transactionType;
      this.halkbank.amount = result.amount;
      this.halkbank.oid = result.oid;
      this.halkbank.okUrl = result.okUrl;
      this.halkbank.failUrl = result.failUrl;
      this.halkbank.rnd = result.rnd;
      this.halkbank.instalmentCount = result.instalmentCount;
      this.HalkFormGroup.patchValue({hash: result.hash});
      // this.HalkFormGroup.patchValue({clientid: result.clientId});//f
      this.HalkFormGroup.patchValue({storetype: this.halkbank.storetype});
      this.HalkFormGroup.patchValue({trantype: result.transactionType});
      this.HalkFormGroup.patchValue({amount: result.amount});
      this.HalkFormGroup.patchValue({currency: this.halkbank.currency});
      this.HalkFormGroup.patchValue({oid: result.oid});
      this.HalkFormGroup.patchValue({okUrl: result.okUrl});
      this.HalkFormGroup.patchValue({failUrl: result.failUrl});
      this.HalkFormGroup.patchValue({lang: this.halkbank.lang});
      this.HalkFormGroup.patchValue({rnd: result.rnd});
      this.HalkFormGroup.patchValue({encoding: this.halkbank.encoding});
      this.HalkFormGroup.patchValue({refreshtime: this.halkbank.refreshtime});
      this.HalkFormGroup.patchValue({instalment: this.halkbank.instalmentCount});
      this.HalkFormGroup.patchValue({RecurringPaymentNumber: '6'});
      this.HalkFormGroup.patchValue({RecurringFrequencyUnit: 'M'});
      this.HalkFormGroup.patchValue({RecurringFrequency: '1'});
      this.spinner = true;
      this.postingToHalk = true;
      },(error) => {
        this.spinner = false;
        this.postingToHalk = false;
      })
  }

  ngAfterViewChecked() {
    if (this.postingToHalk && this.HalkFormGroup) {
      this.HalkForm.nativeElement.submit();
    }
  }
}
